import { render, staticRenderFns } from "./SubscriptionRequest.vue?vue&type=template&id=cdd43c24&scoped=true"
import script from "./SubscriptionRequest.vue?vue&type=script&lang=js"
export * from "./SubscriptionRequest.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionRequest.vue?vue&type=style&index=0&id=cdd43c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd43c24",
  null
  
)

export default component.exports